import Tooltip from "@mui/material/Tooltip"

const withTooltip = (Component, tooltipText) => {
  return function WrappedComponent(props) {
    return (
      <Tooltip title={tooltipText}>
        <div>
          <Component {...props} />
        </div>
      </Tooltip>
    )
  }
}

export default withTooltip
